import React, { createContext, useContext, useState, useCallback, ReactNode } from "react";
import TaskModal from "./TaskModal";
import { TaskModalProps } from "./plan/context";

interface TaskModalContextType {
    setTaskModal: (props: TaskModalProps) => void;
    closeTaskModal: () => void;
}

const TaskModalContext = createContext<TaskModalContextType | null>(null);

export const useTaskModal = (): TaskModalContextType | null => {
    return useContext(TaskModalContext);
};

interface TaskModalProviderProps {
    children: ReactNode;
}

export const TaskModalProvider: React.FC<TaskModalProviderProps> = ({ children }) => {
    const [taskModalProps, setTaskModalProps] = useState<TaskModalProps | null>(null);

    const setTaskModal = useCallback((props: TaskModalProps) => {
        setTaskModalProps(props);
    }, []);

    const closeTaskModal = useCallback(() => {
        setTaskModalProps(null);
    }, []);

    const handleToggle = useCallback(() => {
        setTaskModalProps(null);
    }, []);

    return (
        <TaskModalContext.Provider value={{ setTaskModal, closeTaskModal }}>
            {children}
            {taskModalProps && (
                <TaskModal
                    key={taskModalProps.taskUUID}
                    {...taskModalProps}
                    toggle={handleToggle}
                    onOpenTask={(taskUuid, fromDate) => {
                        setTaskModalProps({ taskUUID: taskUuid, fromDate });
                    }}
                />
            )}
        </TaskModalContext.Provider>
    );
};
